import { useEffect, useState } from "react";


export const ONE_MINUTE = 1000 * 60;
export const TWENTY_MINUTES = 1000 * 60 * 20;
export const ONE_HOUR = 1000 * 60 * 60;


const useTimeSpentOnPage = () => {

    // State to track the elapsed time
    const [minutesSpentInCompenent, setElapsedTime] = useState(0);
    const [startTime, setStartTime] = useState(Date.now());// Capture the initial time when the component mounts

    function resetTime() {

        setStartTime(Date.now());
        setElapsedTime(0);
    }

    useEffect(() => {

        const interval = setInterval(() => {
            
            const currentTime = Date.now();
            const elapsedSeconds = Math.floor((currentTime - startTime) / 1000); // Calculate elapsed time in seconds
            setElapsedTime(Math.floor(elapsedSeconds / 60)); // Convert seconds to minutes
        }, 1000);

        return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, []);

    return {
        minutesSpentInCompenent, resetTime
    };
}

export default useTimeSpentOnPage;